module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/path-2f25f527fa8774e8cfb070255d5ba742.svg";